module.exports = __webpack_public_path__ + "img/maestro.bb851e9.svg";